export default __webpack_public_path__ + "static/media/KeyObservationsWithEdit.33b35f2f.png";